module.exports = __webpack_public_path__ + "img/Dantam Hair 57.a5a6e913.jpg";